import { MAIN_LANDING_PAGE } from "../constants";
import { CopyrightFooter } from "../CopyrightFooter";
import { ConfirmationModal } from "./ConfirmationModal";

interface Props {
  isOpen: boolean;
  toggle: () => void;
}

export const AboutModal = (props: Props) => {
  const body = (
    <>
      <p>
        HerdPlan is a livestock health planning tool that aims to make livestock
        health risk management, quick, easy and effective.
      </p>
      <p>
        HerdPlan uses guided, flexible modules to let you focus on your own farm
        priority areas for immediate business gain. You, in conjunction with
        your vet, can pick from a comprehensive range of modules, including
        production, infectious diseases, fertility, pneumonia, lameness and many
        more and work together on what matters most to your business.
      </p>
      <p>
        Click{" "}
        <a href={MAIN_LANDING_PAGE} target="_blank" rel="noopener noreferrer">
          here
        </a>{" "}
        to find out more.
      </p>
      <CopyrightFooter />
    </>
  );

  return (
    <ConfirmationModal
      {...props}
      confirmLabel={null}
      body={body}
      header="About HerdPlan"
    />
  );
};
